module.exports = __webpack_public_path__ + "static/img/ifc.439cf28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userVal/ifc.png
// module id = rTaw
// module chunks = 0